import { render } from "./turma_add_professor.vue?vue&type=template&id=d2835ada&scoped=true"
import script from "./turma_add_professor.vue?vue&type=script&lang=js"
export * from "./turma_add_professor.vue?vue&type=script&lang=js"

import "./turma_add_professor.vue?vue&type=style&index=0&id=d2835ada&lang=scss&scoped=true"
import "./turma_add_professor.vue?vue&type=style&index=1&id=d2835ada&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"
import "./turma_add_professor.vue?vue&type=style&index=3&id=d2835ada&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2835ada"]])

export default __exports__